var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "panelGroup", staticClass: "cf-node-properties__panel-group row" },
    [
      _c("GenericProps", {
        attrs: {
          "node-id": _vm.node.id,
          settings: _vm.settings,
          "audio-parameters": _vm.audioParameters,
          parameters: _vm.filteredNodeParameters
        },
        on: {
          "update:settings": [
            function($event) {
              _vm.settings = $event
            },
            _vm.updateNodeParent
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cf-node-properties__field col-md-12" },
        [
          _c("legend", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "MENU_ROUTES",
                expression: "'MENU_ROUTES'"
              }
            ],
            staticClass: "cf-node-properties__legend"
          }),
          _vm._v(" "),
          _c(
            "Draggable",
            {
              model: {
                value: _vm.routeList,
                callback: function($$v) {
                  _vm.routeList = $$v
                },
                expression: "routeList"
              }
            },
            _vm._l(_vm.routeList, function(route) {
              return _c("RoutePanel", {
                key: route.id,
                attrs: {
                  index: route.index,
                  route: route,
                  "add-routes": true,
                  sortable: true
                },
                on: {
                  "update:route": function($event) {
                    route = $event
                  },
                  addNodeToRoute: function($event) {
                    return _vm.addNodeToRoute($event, route)
                  }
                }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }